import React from 'react';

import { Button } from '@eika/button';
import { ButtonWithSpinner } from '@eika/button-with-spinner';

import useHasChanged from '../../components/transaction/AvtaleGiro/form/useHasChanged';
import { AvtalegiroAgreementDetails, PaymentSubStatus } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';
import { useSigningContext } from '../../signingContext/signingContext';
import { paymentTrackIDs } from '../../utils/gtm/trackIDs/payment';

type Props = {
    avtalegiroDetails: AvtalegiroAgreementDetails;
    triggerAmountLimitModal: () => void;
    isLoading: boolean;
    restartPayment: () => void;
    paymentItemSubType: PaymentSubStatus | undefined;
};

const StoppedAvtalegiroFormFooter: React.FC<Props> = ({
    avtalegiroDetails,
    restartPayment,
    triggerAmountLimitModal,
    isLoading,
    paymentItemSubType,
}) => {
    const translated = useTranslation();
    const stateHasChanged = useHasChanged(avtalegiroDetails);
    const { signingOperationPending } = useSigningContext();

    return (
        <>
            {paymentItemSubType === 'EXCEEDING_MAX_LIMIT' && !stateHasChanged && (
                <Button onClick={triggerAmountLimitModal}>{translated.avtaleGiroAgreement.editMaxAmount}</Button>
            )}
            {stateHasChanged ? (
                <ButtonWithSpinner
                    buttonType="positive"
                    showSpinner={isLoading || signingOperationPending}
                    type="submit"
                    data-testid="update-stopped-avtalegiro"
                    data-track-id={paymentTrackIDs.stopped.updateStoppedAvtalegiro}
                    data-track-linkname={translated.update}
                >
                    {translated.update}
                </ButtonWithSpinner>
            ) : (
                <ButtonWithSpinner
                    buttonType="negative"
                    showSpinner={isLoading}
                    onClick={restartPayment}
                    data-testid="restart-payment-item"
                    data-track-id={paymentTrackIDs.stopped.paymentItem}
                    data-track-linkname={translated.tryAgain}
                >
                    {translated.tryAgain}
                </ButtonWithSpinner>
            )}
        </>
    );
};

export default StoppedAvtalegiroFormFooter;
